import { Link } from 'react-router-dom';
import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 14px 24px;
  box-shadow: 0px 1px 0px ${({ theme }) => theme.colors.grey000};
  background-color: ${({ theme }) => theme.colors.white};
`;

export const HeaderLogo = styled.img`
  margin: 0;
`;

export const HeaderLink = styled(Link)`
  text-decoration: none;
`;

export const HeaderUserNameWrapper = styled.div`
  position: relative;
  margin-inline-start: auto;
  cursor: pointer;
`;

export const HeaderUserName = styled(typography.BodyTextOneRegularTypography)`
  display: flex;
  margin: 0;
  color: ${({ theme }) => theme.colors.black};

  &:after {
    content: '\\e913';
    font-family: 'Icomoon';
    margin-inline-start: 6px;
  }
`;

export const HeaderLogoutPopup = styled.div`
  position: absolute;
  top: 25px;
  right: 10px;
  width: 100%;
  padding: 20px 25px;
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.grey000};
  border-radius: 8px;
  box-shadow: 0px 4px 16px rgb(${({ theme }) => theme.colors.rgb.black16PercentOpacity});
  z-index: 1;
  text-align: -webkit-center;
`;

export const LogoutBtn = styled.div`
  color: ${({ theme }) => theme.colors.black};
  background-color: ${({ theme }) => theme.colors.grey100};
  border: 1px solid ${({ theme }) => theme.colors.grey300};
  border-radius: 4px;
  margin: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 10px 0px;
`;

export const HeaderLogout = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
  font-size: 14px;
`;

export const HeaderLogoutIcon = styled.i`
  color: ${({ theme }) => theme.colors.grey002};
  font-style: normal;
  margin-inline-end: 5px;
  &:before {
    font-size: 14px;
    content: '\\e916';
    font-family: 'Icomoon';
  }
`;

export const HeaderUserNameLoaderWrapper = styled.div`
  margin-inline-start: auto;
`;

export const HeaderLogoutConfirmation = styled.div`
  margin-bottom: 10px;
  width: max-content;
`;
